module.exports = __webpack_public_path__ + "static/media/yuta-6.jpeg";